<template>
    <div class="row" v-if="!loading && templates.length">
        <template-thumb
            :showSidebar="false"
            v-for="template in templates"
            :key="template.id"
            :template="template"
        />
    </div>
    <div class="col-md-12" v-else-if="!loading && !templates.length">
        <h3 class="text-center mt-4">No similar template found.</h3>
    </div>
    <div class="col-md-12" v-else>
        <a-skeleton active />
    </div>
</template>

<script>
import { HTTP } from "../api";
import TemplateThumb from "./template-thumb.vue";

export default {
    components: {
        TemplateThumb,
    },
    props: ["template"],
    data() {
        return {
            templates: [],
            loading: true,
        };
    },
    methods: {
        async fetchSimilarTemplates() {
            this.loading = true;
            try {
                const { data } = await HTTP.get(
                    `/templates/${this.template}/similar`
                );
                this.templates = data?.templates;
            } catch (error) {
                console.log("Error", error);
                this.$notification.error({
                    message: "Something went wrong",
                    description:
                        "Please try again later to get expected results",
                });
            }
            this.loading = false;
        },
    },
    created() {
        this.fetchSimilarTemplates();
    },
};
</script>
